import React from 'react';
import LegalPage from '../components/LegalPage';
import { privacyPolicy } from '../data/legal';

export default function PrivacyPolicyPage() {
  return (
    <LegalPage
      eyebrow="Legal"
      title="Privacy Policy"
      updated={privacyPolicy.updated}
      body={privacyPolicy.body}
      testId="privacy-policy-page"
    />
  );
}
